export default __webpack_public_path__ + "static/media/clic-hand.19e2bc99.svg";